module.exports = __webpack_public_path__ + "static/media/InConnect.7e90b9a2.svg";